<!--
 * @Author: name
 * @Date: 2021-01-03 02:26:24
 * @Description: 
-->
<template>
  <div class="homepage">
    <v-carousel
      cycle
      height="350"
      hide-delimiter-background
      show-arrows-on-hover
      hide-delimiters
      class="mobile-display"
    >
      <v-carousel-item>
        <v-parallax height="350" src="../assets/images/common/banner1.jpg">
            <v-container fill-heigh>
              <v-row
                align="center"
                class="white--text mx-auto"
                justify="center"
              >
                <v-col
                  class="white--text text-center fadeIn"
                  cols="12"
                  tag="h1"
                >
                  <span class="font-weight-light display-1">{{
                    $t("i18n.welcome")
                  }}</span>
                  <br />
                  <span class="font-weight-bold welcome-title">{{
                    $t("i18n.company")
                  }}</span>
                </v-col>
              </v-row>
            </v-container>
        </v-parallax>
      </v-carousel-item>
      <v-carousel-item>
        <v-parallax height="350" src="../assets/images/common/banner2.jpg">
            <v-row align="center" class="white--text mx-auto" justify="center">
              <v-col class="white--text text-left fadeIn" cols="12" md="12">
                <span class="font-weight-medium display-1">{{
                  $t("i18n.bannerText").first
                }}</span>
                <br />
                <span
                  class="font-weight-medium display-1"
                  style="margin-left: 20px"
                  >{{ $t("i18n.bannerText").second }}</span
                >
              </v-col>
            </v-row>
        </v-parallax>
      </v-carousel-item>
    </v-carousel>
    <!--介绍-->
    <section id="introduction">
      <div class="py-8"></div>
      <v-container class="text-center" transition="slide-x-reverse-transition">
        <v-responsive
          class="mx-auto font-weight-regular text-justify"
          max-width="1200"
          style="text-indent: 2em; font-size: 20px"
        >
          <p>{{ $t("i18n.introductionText1") }}</p>
        </v-responsive>
      </v-container>
    </section>
    <!--案例-->
    <section id="cases">
      <v-container class="text-center fadeIn">
        <h3 class="font-weight-medium mb-3 item-title">
          {{ $t("i18n.caseTitle") }}
        </h3>
        <v-divider
          style="margin-right: 30% !important;
    margin-left: 30% !important;"
        ></v-divider>
        <v-responsive class="mx-auto mb-6" width="56"></v-responsive>
        <v-row>
          <v-col>
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide
              v-for="({ img, title, text, index }, i) in $t('i18n.caseCards')"
              :key="i"
              ><v-card class="mx-auto my-12 casecard" max-width="374">
                <v-img class="img" height="300" :src="img"></v-img>
                <v-card-title>{{ title }}</v-card-title>
                <v-divider class="mx-4"></v-divider>
                <v-card-text class="card-text">{{ text }}</v-card-text>
                <v-card-actions>
                  <v-btn class="card-btn" text @click="more(index)">
                    {{$t('i18n.more')}} >
                  </v-btn>
                </v-card-actions>
              </v-card></swiper-slide
            >
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
          </v-col>
        </v-row>
      </v-container>
      <div class="py-8"></div>
    </section>
    <!--优势特色-->
    <section id="points">
      <div class="py-8"></div>
      <v-container class="text-center fadeIn">
        <h3 class="font-weight-medium mb-3 item-title">
          {{ $t("i18n.proTitle") }}
        </h3>
        <v-divider
          style="margin-right: 30% !important; margin-left: 30% !important"
        ></v-divider>
        <v-responsive class="mx-auto mb-6" width="56"></v-responsive>
        <v-row>
          <v-col
            v-for="({ icon, title, text }, i) in $t('i18n.proCards')"
            :key="i"
            cols="12"
            md="4"
          >
            <v-card
              class="py-8 px-4 content-light2 point-card"
              color="lighten-3"
            >
              <v-theme-provider dark>
                <div>
                  <v-avatar size="100">
                    <v-img
                      height="80px"
                      contain
                      class="rotate-img"
                      :src="icon"
                    ></v-img>
                  </v-avatar>
                </div>
              </v-theme-provider>
              <v-card-title
                class="justify-center point-card-title font-weight-regular text-uppercase"
                >{{ title }}</v-card-title
              >
              <v-card-text class="point-card-text">{{ text }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <div class="py-8"></div>
    </section>
    <!--新闻-->
    <section id="news" hidden>
      <div class="py-8"></div>
      <v-container class="text-center fadeIn">
        <h3 class="font-weight-medium mb-3 item-title">
          {{ $t("i18n.news") }}
        </h3>
        <v-divider
          style="margin-right: 30% !important; margin-left: 30% !important"
        ></v-divider>
        <v-responsive class="mx-auto mb-6" width="56"></v-responsive>
        <v-row>
          <v-col>
          <v-card
            class="mx-auto news-card"
            outlined
            v-for="({ title, text, time, img }, i) in $t('i18n.newsdata')"
            :key="i"
          >
            <v-list-item three-line>
              <v-list-item-avatar
                tile
                size="120"
                color="grey"
              >
              <v-img :src="img"></v-img></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h5 mb-1">
                  {{ title }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ text }}</v-list-item-subtitle>
                <v-card-text class="news-time">{{ time }}</v-card-text>
              </v-list-item-content>
            </v-list-item>
          </v-card>
          </v-col>
        </v-row>
      </v-container>
      <div class="py-8"></div>
    </section>
    <!--合作伙伴-->
    <section id="partner">
      <v-container class="text-center">
        <h3 class="font-weight-medium mb-3 item-title">
          {{ $t("i18n.partner") }}
        </h3>
        <v-divider
          style="margin-right: 30% !important;margin-left: 30% !important;"
        ></v-divider>
        <v-responsive class="mx-auto mb-6" width="56"> </v-responsive>
        <v-row>
          <v-col
            v-for="({ url, icon, name }, i) in $t('i18n.partners')"
            :key="i"
            cols="12"
            md="3"
          >
            <v-card class="py-4 px-4 content-light" flat style="height: 100%">
              <v-theme-provider>
                <a v-if="url != ''" :href="url" target="_blank">
                  <img :src="icon" height="65px" />
                </a>
                <img v-else :src="icon" height="65px" />
              </v-theme-provider>
              <v-card-title
                class="
                  justify-center
                  font-weight-regular
                  text-uppercase
                  content-text
                "
                v-text="name"
              ></v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <div class="py-8"></div>
    </section>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  name: "HomePage",
  data() {
    return {
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 5,
        slidesPerGroup: 1,
        loop: false,
        autoplay: {
          delay: 50000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
          type: "bullets",
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    more(index) {
      var path = "../products/"
      this.$router.push({ path: path ,query: {
                            index:index
                        }}).catch(error => error);
      this.$store.dispatch("updateCurrentPage", 'products');
    },
  },
};
</script>
<style lang="scss" scoped>
#points {
  background: #f6f8fa;
}
.casecard {
  overflow: hidden;
  .img {
    transition: all 0.8s ease;
  }
  .img:hover {
    transform: scale(1.05);
  }
  .card-text {
    text-align: left;
    width: fit-content;
    margin-right: 0px;
    height: 100px;
  }
  .card-btn {
    color: #019fe8;
  }
}
.point-card {
  height: 300px;
  background: #019fe8 !important;
}
.point-card-title {
  display: inline-block;
  color: #fff;
}
.point-card-text {
  color: #fff !important;
}
.news-title {
  font-size: 30px;
}
.news-text {
  font-size: 20px;
}
.content-light {
  border: 2px solid #019fe8 !important;
  border-radius: 10px !important;
}
.content-light:hover {
  box-shadow: #019fe8 0 0 15px;
}
.news-card{
  width: 100%;
  text-align: left;
}
.news-card:hover {
  border: 1px solid #019fe8;
}
.news-time {
  text-align: right;
}
</style>
